import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import UserHeader from './components/UserHeader';
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import ToastContainer from './components/Toast/ToastContainer';
import Landing from './pages/Landing.tsx';
import Dashboard from './pages/Dashboard';
import PropertiesPage from './pages/PropertiesPage';
import SiteFinderPage from './pages/SiteFinderPage';
import ChatPage from './pages/ChatPage';
import './styles/globals.css';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <ProtectedRoute>
            <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
              <UserHeader />
              <Header />
              <div className="flex">
                <Sidebar />
                <main className="flex-1 min-w-0 overflow-auto">
                  <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/properties" element={<PropertiesPage />} />
                    <Route path="/site-finder" element={<SiteFinderPage />} />
                    <Route path="/chat" element={<ChatPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </main>
              </div>
              <ToastContainer />
            </div>
          </ProtectedRoute>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;